/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".remax-input.full-width[_ngcontent-%COMP%]{width:100%}.remax-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{background-color:#fff;border-color:#007dc3;border-radius:4px}.remax-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:disabled{background-color:#edeff0}.remax-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{box-shadow:inset 0 0 3px 2px Highlight}"];
export { styles as styles };
